import FavsWidget from '../FilmFavs/FavsWidget';
import { bookFavsConfig } from './config';

const BookFavs = () => <FavsWidget config={bookFavsConfig} />;

export default BookFavs;
